<template lang="pug">

a-assets(timeout="600000")
  img(
    ref="images"
    v-for="asset of assets"
    v-if="asset.type === 'img'"
    :key="asset.id"
    :id="asset.id"
    :src="asset.src"
    crossorigin=''
  )
  video(
    ref="videos"
    v-for="asset of assets"
    v-if="asset.type === 'video'"
    :key="asset.id"
    :id="asset.id"
    loop
    muted
    playsinline='true'
    preload
    autobuffer
    x5-playsinline='true'
    webkit-playsinline='true'
    crossorigin='anonymous'
    style="display:none"
    x5-video-player-type='h5'
    x5-video-player-fullscreen='true'
    x5-video-player-orientation='portrait'

  )
    source(:src="asset.src" type="video/mp4")
  audio(
    ref="audios"
    v-for="asset of assets"
    v-if="asset.type === 'audio'"
    :key="asset.id"
    :id="asset.id"
    :src="asset.src"
    crossorigin=''
  )
  a-asset-item(
    ref="others"
    v-for="asset of assets"
    v-if="asset.type === 'other'"
    :key="asset.id"
    :id="asset.id"
    :src="asset.src"
    crossorigin=''
  )

</template>

<script>
import { mapState } from 'vuex'

let getLoadEvtName = function(tagName) {
  let evtName
  switch (tagName.toLowerCase()) {
    case 'img':
      evtName = 'load'
      break
    case 'a-asset-item':
      evtName = 'loaded'
      break
    case 'video':
      evtName = 'loadeddata'
      break
    case 'audio':
      evtName = 'canplaythrough'
      break
  }
  return evtName
}

export default {
  name: 'loader',
  components: {},
  data() {
    return {
      startTime: Date.now(),
      itemsLoaded: 0,
      progress: 0,
      showProgress: 0,
      completed: false,
    }
  },
  props: {
    id: {
      required: true,
    },
    assets: {
      required: true,
    },
    minTime: {
      default: 2500,
    },
  },
  computed: {
    ...mapState('app', ['debug']),
  },
  mounted() {
    window.Loader = this
    this.listen()
  },
  beforeDestroy() {
    this.unlisten()
  },
  methods: {
    onItemLoaded() {
      this.itemsLoaded++
      this.progress = this.itemsLoaded / this.assets.length
      // console.log(777, this.progress, this.itemsLoaded, this.assets.length)
    },
    onLoadComplete() {
      // this.progress = 1
      this.completed = true
    },
    loadUrl(url, onLoad) {
      // console.log(111, 'loadUrl', url)
      var request = new XMLHttpRequest()
      request.open('GET', url, true)
      request.responseType = 'blob'
      request.onload = onLoad
      // function() {
      //   if (this.status == 200) {
      //     var audio = new Audio(URL.createObjectURL(this.response))
      //     audio.load()
      //     audio.play()
      //   }
      // }
      request.send()
    },
    listen() {
      for (let item of this.$el.children) {
        let tagName = item.tagName.toLowerCase()
        switch (tagName) {
          case 'audio': {
            this.loadUrl(item.src, this.onItemLoaded)
            break
          }
          case 'img': {
            let evtName = getLoadEvtName(tagName)
            item.addEventListener(evtName, () => {
              let textureCache = document.querySelector('a-scene').systems['texture-cache']
              textureCache.getTexture(item, this.onItemLoaded)
            })
            break
          }
          default: {
            let evtName = getLoadEvtName(tagName)
            item.addEventListener(evtName, this.onItemLoaded)
            break
          }
        }
      }
      this.$el.addEventListener('loaded', this.onLoadComplete)
      this.updateInterval = setInterval(this.update, 1000 / 30)
    },
    unlisten() {
      for (let item of this.$el.children) {
        let evtName = getLoadEvtName(item.tagName)
        item.removeEventListener(evtName, this.onItemLoaded)
      }
      this.$el.removeEventListener('loaded', this.onLoadComplete)
      clearInterval(this.updateInterval)
    },
    update() {
      let actualProgress = this.progress
      if (this.completed) actualProgress = 1

      let minTime = this.minTime
      if (this.debug) minTime = 0
      let maxProgress = (Date.now() - this.startTime) / minTime
      maxProgress = Math.min(maxProgress, 1)

      let showProgress = Math.min(actualProgress, maxProgress)
      showProgress = Math.min(showProgress, 1)

      this.showProgress = showProgress
    },
    onComplete() {
      this.unlisten()
      this.progress = 1
      this.showProgress = 1
      this.$emit('completed', {
        id: this.id,
      })
    },
  },
  watch: {
    showProgress(val) {
      this.$emit('progress', {
        id: this.id,
        progress: val,
      })

      if (val >= 1 && this.completed) {
        this.onComplete()
      }
    },
  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.loader
  +full()
  +flex-center()

</style>
